<template>
  <div>
    <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
      <v-container class="contain-width">

        <v-row>
          <v-col
              md="8"
              offset-md="2"
          >
            <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Intro Membership Activ8') }}</h1>
            <v-card
                class="mx-auto form-card"
                outlined
            >

              <v-card-text class="text--primary">
                <p class="text-h4">{{ $t("Welcome {name}, you have successfully registered with {brand}", {name: user.name, brand: brand}) }}.</p>

                <p class="body-1">{{ $t("We have activated your tag which can now be scanned to help return your property") }}.</p>

                <v-alert
                    type="info"
                    color="info"
                    border="left"
                >
                  <v-row align="center">
                    <v-col class="grow pt-0">
                      <div class="text-h6 mb-6">
                        {{ $t('headings.Please verify your email address') }}
                      </div>
                      <p class="body-1">{{ $t("Please check your inbox for an email we sent to {email} from {support}", {email: user.email, support: supportEmail}) }}</p>
                      <p class="body-1">{{ $t("You will need to confirm your email address before you can access all website features") }}.</p>
                      <p class="body-1 mb-0">{{ $t("Please make sure you are logged in on the same device and browser, that the email link opens in") }}.</p>
                    </v-col>
                  </v-row>

                </v-alert>

                <p class="body-1">{{ $t("More") }} <v-img
                    class="white--text activ8-logo"
                    width="80px"
                    :src="activ8Logo"
                    eager
                >
                </v-img> {{ $t("headings.tags") }}? <router-link to="/account">{{ $t('links.activate them here') }}</router-link>.</p>

                <p class="body-1">{{ $t("Your tag has been made public, to enable anyone who finds your property to scan the tag, and return the item to you") }}. {{ $t("You can restrict this to registered organisations only from your") }} <router-link to="/account">{{ $t('links.Dashboard') }}</router-link>.

                <p class="body-1">{{ $t("To buy more tags for yourself, friends, family and dependants, please subscribe from your") }} <router-link to="/account">{{ $t('links.Dashboard') }}</router-link>.</p>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "InstantActivateSuccess",
  mounted () {

    this.$gtag.pageview({
      page_path: '/intro-activate-success'
    })

  },
  computed: {
    ...mapState({
      user: state => state.account.user,
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    getBackground() {
      if (this.brand === 'neotag') {
        return require('@/assets/neotag-background.jpg')
      }
      else {
        return require('@/assets/hp-banner-1.jpg')
      }
    },
    activ8Logo() {
      if (this.brand === 'neotag') {
        return require('@/assets/activ8-logo-alpha-dark.png')
      }
      return require('@/assets/activ8-logo.png')
    },
    supportEmail() {
      if (this.brand === 'neotag') {
        return 'info@neotag.es'
      }
      else {
        return 'support@findmykit.com'
      }
    }
  },
}
</script>

<style scoped>
  .activ8-logo {
    display: inline-block;
    margin-bottom: -7px
  }
</style>
